module.exports = __webpack_public_path__ + "static/media/doctor.18cdace3.png";